import React, { useState } from "react";
import { array, object, string } from "prop-types";
import get from "lodash/get";
import { connect } from "react-redux";

import CollectionTitleWithArrow from "../../atoms/CollectionTitleWithArrow";
import WideStoryCard from "../../molecules/WideStoryCard";
import NumberedStoryItem from "../../molecules/NumberedStoryItem";
import LeftArrowButton from "../../atoms/icons/left-arrow-button";
import RightArrowButton from "../../atoms/icons/right-arrow-button";
import ScrollSnap from "../../atoms/ScrollSnap";

import { getSlug, getCollectionName } from "../../utils/utils";

import "./oneColThreeStoriesSlider.m.css";

const OneColThreeStoriesSlider = ({ collection, sections, domainSlug }) => {
  if (!(collection && collection.items && collection.items.length)) {
    return null;
  }

  const showCollectionName = get(collection, ["associated-metadata", "show_collection_name_website"], null);
  const navigateTo = get(collection, ["associated-metadata", "navigate_to"], "");
  const navigateToTitle = get(collection, ["associated-metadata", "navigate_to_title"], "");
  const showAutoScroll = get(collection, ["associated-metadata", "enable_auto_scroll"], false);
  const slidingTime = get(collection, ["associated-metadata", "sliding_time"], 10000);

  const collectionName = getCollectionName(collection, navigateToTitle);
  const collectionSlug = navigateTo ? `/${navigateTo}` : getSlug(collection, sections, domainSlug);

  const stories = collection.items
    .filter((item) => item.type === "story")
    .map((item) => item.story);
  const children = stories.map((story, index) => (
    <WideStoryCard
      key={index}
      story={story}
      aspectRatio={global.deviceWidth < 876 ? [2, 3] : [16, 7]}
      widths={[1200]}
      imageType={global.deviceWidth < 876 ? "image2x3" : "image1248x546"}
      updatedFont={true}
    />
  ));
  const [selectedIndex, setSelectedIndex] = useState(0);
  const selectionChange = (index) => setSelectedIndex(index);

  return (
    <div styleName="wrapper">
      {showCollectionName && (
        <CollectionTitleWithArrow
          collectionName={collectionName}
          collectionSlug={collectionSlug}
          headlineClassName="collection-name-arrow"
          updatedFont={true}
        />
      )}

      <div styleName="story">
        <ScrollSnap
          selectionChange={selectionChange}
          defaultSelection={selectedIndex}
          leftArrow={<LeftArrowButton />}
          rightArrow={<RightArrowButton />}
          isArrow={true}
          isIndicator={true}
          isInfinite={showAutoScroll}
          interval={slidingTime}
        >
          {children}
        </ScrollSnap>
      </div>
    </div>
  );
};

OneColThreeStoriesSlider.propTypes = {
  collection: object,
  sections: array,
  domainSlug: string,
};

const mapStateToProps = (state) => ({
  sections: get(state, ["qt", "config", "sections"], []),
  domainSlug: get(state, ["qt", "config", "domainSlug"], ""),
});

export default connect(mapStateToProps)(OneColThreeStoriesSlider);
